import { inject } from '@angular/core';
import { HostAccApiService } from '@shared/services';
import { TableConfig, PLACEHOLDER_FUNCTIONS } from '../generic-p-table.interfaces';

export const hostAccTableConfig = (): TableConfig => {
  const hostAccApiService = inject(HostAccApiService);

  return {
    title: 'Quản lý tài khoản host',
    entityName: 'tài khoản host',
    service: hostAccApiService,
    method: 'getHostAccs',
    columns: [
      { field: 'code', header: 'Mã', width: 'min-w-[120px]', sortable: true, type: 'text' },
      { field: 'name', header: 'Tên', width: 'min-w-[200px]', sortable: true, type: 'text' },
      { field: 'email', header: 'Email', width: 'min-w-[100px]', sortable: true, type: 'text' },
      { field: 'status', header: 'Trạng thái', width: 'min-w-[150px]', sortable: true, type: 'tag', tagType: 'hostAccStatus' },
      { field: 'renewalType', header: 'Loại gia hạn', width: 'min-w-[150px]', sortable: true, type: 'tag', tagType: 'hostAccRenewalType' },
      { field: 'renewDate', header: 'Ngày gia hạn', width: 'min-w-[150px]', sortable: true, type: 'date', dateFormat: 'dd/MM/yyyy' },
      { field: 'note', header: 'Ghi chú', width: 'min-w-[200px]', sortable: false, type: 'text' }
    ],
    features: {
      virtualScroll: true,
      toolbar: true
    },
    actions: [
      {
        location: 'toolbar',
        useDefaultStyle: 'add',
        onClick: PLACEHOLDER_FUNCTIONS.OPEN_NEW
      },
      {
        location: 'row',
        useDefaultStyle: 'edit',
        onClick: PLACEHOLDER_FUNCTIONS.EDIT
      }
    ]
  };
};

